// Generate default config object
export const generateDefaultConfig = () => {
  // Determine environment based on hostname and NODE_ENV
  const hostname = window.location.hostname;
  const nodeEnv = process.env.NODE_ENV || '';

  const isStaging =
    hostname.includes('staging') ||
    hostname.includes('dev') ||
    hostname.includes('test') ||
    nodeEnv === 'staging';
  const isProduction = hostname.includes('app.zoominfo.com') || nodeEnv === 'production';

  // Set DOZI URL based on environment
  let doziUrl = '';
  if (isStaging) {
    doziUrl = 'https://dozi-staging.zoominfo.com/#/';
  } else if (isProduction) {
    doziUrl = 'https://app.zoominfo.com/#/';
  }

  const config = {
    // Static values
    BE_ENDPOINT_NON_ZI: `https://${window.location.host.split('.')[0]}.api.insent.ai/`,
    NODE_ENV: process.env.NODE_ENV,
    ZI_COOKIE: 'ziaccesstoken',
    BE_ENDPOINT_ZI: `https://${window.location.host.split('.')[0]}.api.zoominfo.com/`,
    // Set REACT_APP_DOZI_URL based on environment
    REACT_APP_DOZI_URL: doziUrl,
  };
  return config;
};

// Merge API config with default config
export const mergeConfigs = (defaultConfig, apiConfig) => {
  const merged = { ...defaultConfig, ...apiConfig };
  return merged;
};
